import { acceptHMRUpdate, defineStore } from 'pinia'

export const useUserHistoryStore = defineStore('userHistory', {
  persist: {
    storage: piniaPluginPersistedstate.cookies({
      maxAge: 60 * 60 * 24 * 365,
    }),
  },
  
  state: () => ({
    history: []
  }),

  actions: {
    reset() {
      this.$reset()
    },

    addToHistory(obj) {
      const historyObj = structuredClone(obj)
      this.history = useUniqueBy([historyObj, ...this.history], 'slug').slice(0, 10)
    },

    removeFromHistory(obj) {
      this.history = this.history.filter(historyObj => historyObj.href !== obj.href)
    },
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserHistoryStore, import.meta.hot))
}
